import { render, staticRenderFns } from "./MobileLink.vue?vue&type=template&id=661513d9&scoped=true&"
import script from "./MobileLink.vue?vue&type=script&lang=js&"
export * from "./MobileLink.vue?vue&type=script&lang=js&"
import style0 from "./MobileLink.vue?vue&type=style&index=0&id=661513d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661513d9",
  null
  
)

export default component.exports